// extracted by mini-css-extract-plugin
export default {"root":"_1pG8l","left-aligned":"_2WSbv","leftAligned":"_2WSbv","right-aligned":"_1vIrA","rightAligned":"_1vIrA","heading":"_8DDGE","postfix":"_2grTi"};